class MyQuestionsController {
    
    draw(context){
        let tabs = new Tabs();
        baseController.resetStackableOrder();
        baseController.drawMainMenu(tabs.QUIZFIT_TAB);

        context.isUserSupervisor = user.isSupervisor();
        context["smile1Icon"] = customIcons["RATE_SMILE_1"];
        context["cuestionMedianUp"] = Math.ceil(context.result.total_questions_added_median);

        let template = Handlebars.compile($("#myQuestionsFragment").html());
        let tab = baseController.getTabById(tabs.QUIZFIT_TAB);
        baseController.stackView(tab, template, context);

        let numQuestionsRejected = context.result.total_questions_rejected;
        let numQuestionsPending = context.result.total_questions_pending;
        let numQuestionsAccepted = context.result.total_questions_accepted;

        let serieData = [];
        let serieColors = [];

        if (numQuestionsAccepted > 0) { serieData.push(['', numQuestionsAccepted]); serieColors.push('#6CC33C'); }
        if (numQuestionsPending > 0) { serieData.push(['', numQuestionsPending]); serieColors.push('#00B3E6'); }
        if (numQuestionsRejected > 0) { serieData.push(['', numQuestionsRejected]); serieColors.push('#F5222D'); }

        if (numQuestionsRejected == 0 && numQuestionsPending == 0 && numQuestionsAccepted == 0) {
            serieData.push(['', 1]); serieColors.push('rgba(255,255,255,0.5)');
        }

        $('#my-questions-challenges-chart').highcharts({
            chart: {
                backgroundColor: 'rgba(255,255,225,0.0)'
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            title: {
                text: '',
                align: 'center',
                floating: true
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false
                    },
                    borderColor: null,
                    center: ['50%', '50%'],
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: [{
                type: 'pie',
                innerSize: '85%',
                data: serieData,
                colors: serieColors
            }]
        });

        $('.smile').each(function () {
            let rate = $(this).data('rate');
            $(this).css('background-image', 'url(' + customIcons["RATE_SMILE_" + rate] + ')').css('background-color', 'white')
        });

        // let iconsColor = 'red';
        //
        // $('.smile-progress').each(function(i, elem) {
        //     let progress = parseFloat($(elem).attr('data-progress'));
        //     $(elem).find('.progress').each(function(j, child) {
        //         let width = Math.max(Math.min(progress - j, 1), 0) * 100;
        //
        //         if(j == 2 && width > 0){
        //             iconsColor = 'orange';
        //         } else if(j == 3 && width > 0){
        //             iconsColor = 'green';
        //         }
        //
        //         $(child).css('width', width+'%');
        //     });
        //
        //     let backgroundProgress = null;
        //     let backgroundIcon = null;
        //
        //     $(elem).find('.progress').each(function(j, child) {
        //         backgroundProgress = 'url(/images/smilie0' + (j+1) + '-' + iconsColor + 'fill.png)';
        //         backgroundIcon = 'url(/images/smilie0' + (j+1) + '-' + iconsColor + '.png)';
        //         $(child).css('background-image', backgroundProgress);
        //         $(child).parent().css('background-image', backgroundIcon);
        //     });
        // });

        setTimeout(MyQuestionsController.adjustHeight, 50);

    };

    static adjustHeight() {

        let content = $('#my-questions-fragment');
        let contentTop = content.offset().top;
        let contentBottom = contentTop + content.outerHeight();

        let windowHeight = $(window).height();

        let diff = windowHeight - contentBottom;
        if (diff > 0) {

            let tables = content.find('table');
            let numTables = tables.length;

            let extraHeight = Math.floor(diff / numTables);

            tables.each(function(i, table) {
                table = $(table);
                let tableHeight = table.outerHeight();
                table.outerHeight(tableHeight + extraHeight);
            });

            if (diff % numTables != 0) {
                let lastTable = tables.last();
                lastTable.outerHeight(lastTable.outerHeight() + 1);
            }

        }

    }

}